export default __webpack_public_path__ + "images/8c5d8f3fa912d099baa5071bda8364d2.svg";